import React, { useEffect, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
  AvatarGroupItem,
  AvatarGroupPopover,
  AvatarGroup,
  partitionAvatarGroupItems,
} from "@fluentui/react-components";

import {
  FlagIcon,
  CheckmarkCircleIcon,
  DismissCircleIcon,
  DoneBadge,
  InProgressBadge,
  MeatBallsMenuIcon,
  ToDoBadge,
} from "../../../../../modules/default-svg";
import { useState } from "react";
import { dateOnlyFormatted } from "../../../../../utils/systemSettings";
import HoverCard from "../../../../hoverCard/HoverCard";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const TaskRow = (props) => {
  const {
    sortingCriteria,
    data,
    handleModal,
    menu,
    scopeId,
    sortTasksRequest,
    updateFlag,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const popoverRef = useRef(null);
  const [setting] = useState(settings);

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      sortTasksRequest({
        id: scopeId,
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      });
    }
  }, [sortingCriteria]);

  const getPriority = (priority) => {
    switch (priority) {
      case 0:
        return "Low";
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "";
    }
  };

  const getPriorityPill = (priority) => {
    switch (priority) {
      case 0:
        return "pill OnTrack";
      case 1:
        return "pill OffTrack";
      case 2:
        return "pill AtRisk";
      default:
        return "";
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 1:
        return <InProgressBadge size={8} />;
      case 2:
        return <DoneBadge size={8} />;
      case 3:
        return <DoneBadge size={8} />;
      default:
        return <ToDoBadge size={8} />;
    }
  };

  const getStatus = (status) => {
    switch (status) {
      case 1:
        return "Monitoring";
      case 2:
        return "Slipping";
      case 3:
        return "Completed";
      default:
        return "In Progress";
    }
  };

  useEffect(() => {
    if (typeof data != "string") {
      setSortedData(data);
    }
  }, [data]);

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
  };

  const getResources = (resources) => {
    const { inlineItems, overflowItems } = partitionAvatarGroupItems({
      items: resources,
    });
    return (
      <AvatarGroup layout="stack" className="listingAvatarGroup">
        {inlineItems.map((item) => (
          <HoverCard
            HoverCardTrigger={
              <AvatarGroupItem
                size={24}
                name={item.resource.name}
                image={{ src: item.resource.image }}
                key={item.resource.name}
              />
            }
            userName={item.resource.name}
            userImage={item.resource.image}
            userDesignation="-----"
          />
        ))}
        {overflowItems && (
          <AvatarGroupPopover>
            {overflowItems.map((item) => (
              <HoverCard
                HoverCardTrigger={
                  <AvatarGroupItem
                    name={item.resource.name}
                    image={{ src: item.resource.image }}
                    key={item.resource.name}
                  />
                }
                userName={item.resource.name}
                userImage={item.resource.image}
                userDesignation="-----"
              />
            ))}
          </AvatarGroupPopover>
        )}
      </AvatarGroup>
    );
  };

  const getEstimatedHours = (assignments) => {
    if (assignments?.length > 0) {
      const estimatedEffort = assignments.reduce((sum, obj) => {
        return sum + parseInt(obj.estimatedEffort);
      }, 0);
      return estimatedEffort;
    }
    return 0;
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
    };
  }, []);

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({ id: id, isFlag: false });
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = sortDataByFlagged(data, flagged);
    setSortedData(sortedArray);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////
  const styles = useStyles();
  return sortedData.map((item) => (
    <TableRow key={item.id} ref={popoverRef}>
      <TableCell>
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center inputWidth">
            <Tooltip
              positioning="before"
              content={{ children: "Flag", className: styles.tooltip }}
              relationship="label"
              withArrow
            >
              <span
                className={`flag ${
                  flagged.includes(item.id) || item.isFlagged
                    ? "flagActive"
                    : ""
                }`}
                onClick={() =>
                  flagged.includes(item.id) || item.isFlagged
                    ? removeFlag(item.id)
                    : addFlag(item.id)
                }
              >
                <FlagIcon />
              </span>
            </Tooltip>
            {item.name}
          </div>
          <div className="flag">
            <Popover
              {...props}
              open={popoverOpen === item.id}
              onOpenChange={(isOpen) => isOpen && handlePopoverOpen(item.id)}
              positioning="below-start"
            >
              <PopoverTrigger disableButtonEnhancement>
                <TableCellLayout
                  media={<MeatBallsMenuIcon />}
                  onClick={() => handleModal(item)}
                />
              </PopoverTrigger>
              <PopoverSurface tabIndex={-1} className="listingPopoverWrapper">
                {menu}
              </PopoverSurface>
            </Popover>
          </div>
        </div>
      </TableCell>
      <TableCell className="text-center">
        {item?.progress ? `${item.progress}%` : ""}
      </TableCell>
      <TableCell className="Description">
        <Tooltip
          withArrow
          positioning="top"
          content={{
            children: <>{item.description}</>,
            className: "ListingTooltip",
          }}
          relationship="description"
        >
          <div className="text-truncate">{item.description}</div>
        </Tooltip>
      </TableCell>
      <TableCell>{item.phase}</TableCell>
      <TableCell className="d-flex items-center gap-2">
        <span className="me-1">{getStatusBadge(item.status)}</span>
        {getStatus(item.status)}
      </TableCell>
      <TableCell>
        <p className={getPriorityPill(item.priority)}>
          {getPriority(item.priority)}
        </p>
      </TableCell>
      <TableCell>
        {item.isCritical ? <CheckmarkCircleIcon /> : <DismissCircleIcon />}
      </TableCell>
      <TableCell>
        {item.isMilestone ? <CheckmarkCircleIcon /> : <DismissCircleIcon />}
      </TableCell>
      <TableCell>
        {item.startDate ? dateOnlyFormatted(setting, item.startDate) : ""}
      </TableCell>
      <TableCell>
        {item.endDate ? dateOnlyFormatted(setting, item.endDate) : ""}
      </TableCell>
      <TableCell>
        {item?.assignments ? getEstimatedHours(item?.assignments) : ""}
      </TableCell>
      <TableCell>
        {item.assignments.length > 0 ? getResources(item.assignments) : ""}
      </TableCell>
    </TableRow>
  ));
};

export default TaskRow;
